import { confirm } from 'cadenza/alert';
import type { ActiveAttributeId } from 'cadenza/workbook/api/active-attribute-id';
import type { DataView } from 'cadenza/workbook/data-view/data-view';
import type { AttributeId } from 'cadenza/workbook/model/attribute-id.gen';

import i18n from './combination-chart-drag-and-drop-utils.properties';

export function combinationChartDiscardingOtherDataViewsConfirmation(
  dataView: DataView,
  attributeId: AttributeId | ActiveAttributeId,
) {
  return confirm(
    i18n('attributeDrop.combinationChart.discardOtherDataViews.header', { name: dataView.name }),
    i18n('attributeDrop.combinationChart.discardOtherDataViews.content', { name: dataView.name }),
    {
      type: 'warning',
      submit: i18n('attributeDrop.combinationChart.confirmDiscardOther'),
      submitCallback: async () => await dataView.addAttribute(attributeId),
    },
  );
}
